import axios from '../axios'
import qs from 'qs'

/**
 * 获取短信验证码
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const getAuthCode = (params) => {
  return axios({
    url: '/contract/api/getAuthCode',
    method: 'get',
    params
  })
}
/**
 * 查询合同列表
 * @param data
 * @returns {*}
 */
export const queryContractList = (params) => {
  return axios({
    url: '/contract/api/queryEmployeeContract',
    method: 'get',
    params
  })
}

export const batchDownload = (params) => {
  return axios({
    url: '/contract/api/batchDownload',
    responseType: 'blob',
    method: 'get',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
  })
};
export const download = (params) => {
  return axios({
    url: '/contract/api/download',
    responseType: 'blob',
    method: 'get',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
  })
};



// WEBPACK FOOTER //
// ./src/http/modules/contract.js